<!-- haiku.component.html (or haiku-pro.component.html if that’s your folder name) -->
<div class="haiku-pro-dialog">
  <button class="close-btn" (click)="close()" aria-label="Close dialog">×</button>

  <div class="header">
    <img
      src="assets/logos/anthropic.svg"
      alt="Claude Haiku 4.5 Logo"
      class="logo"
    />

    <h2>Claude Haiku 4.5</h2>

    <div class="sub">
      Anthropic’s ultra-fast, lightweight model for real-time chat and high-volume work
    </div>
  </div>

  <div class="body">
    <p>
      <strong>Claude Haiku 4.5</strong> is built for speed, responsiveness, and clean execution on
      everyday tasks. It’s a great fit when you want <strong>low-latency answers</strong>,
      <strong>high throughput</strong>, and <strong>consistent formatting</strong>—especially in
      user-facing experiences where performance and cost control matter.
    </p>

    <ul>
      <li>⚡ <strong>Instant responsiveness:</strong> optimized for real-time chat, inline assistance, and quick turnarounds</li>
      <li>🧾 <strong>High-volume friendly:</strong> efficient for support queues, helpdesks, and batch content workflows</li>
      <li>🧠 <strong>Clean instruction following:</strong> reliable with simple steps, templates, and structured output formatting</li>
      <li>✍️ <strong>Strong text transforms:</strong> summarization, rewrite/cleanup, tone shifts, and extraction</li>
      <li>💸 <strong>Cost-efficient production choice:</strong> great default model when you don’t need deep reasoning</li>
    </ul>

    <div class="optimal">
      <h3>Best used for</h3>
      <ul>
        <li>Fast customer support triage, FAQ assistants, and internal helpdesks</li>
        <li>Quick summaries, rewrite/cleanup, and tone adjustments for emails/messages</li>
        <li>Information extraction (entities, bullet points, structured fields)</li>
        <li>Light coding help, simple scripting, and basic debugging guidance</li>
        <li>High-throughput apps that need a responsive, budget-friendly model</li>
      </ul>
    </div>

    <div class="optimal note">
      <h3>Practical note</h3>
      <ul>
        <li>
          Choose <strong>Haiku 4.5</strong> when speed and cost-efficiency matter most.
          For deeper reasoning, long-context projects, or complex analysis, use
          <strong>Sonnet</strong> or <strong>Opus</strong>.
        </li>
      </ul>
    </div>
  </div>
</div>
